import { ISpacing } from '../interfaces/index';

export const DefaultSpacing: ISpacing = {
  s2: '4px',
  s1: '8px',
  m: '16px',
  l1: '20px',
  l2: '32px'
};
